import { ChartContainer } from '../../shared/ChartContainer';
import { EmptyState } from '../../shared/EmptyState';
import type { FpAdvisorLeaderRow } from '../../../../types/analytics.types';

type TopAdvisorsLeaderboardProps = {
  advisors: FpAdvisorLeaderRow[];
};

const TITLE = 'Top Advisors by Engagement';
const SUBTITLE = 'Advisors ranked by total actions in the selected period';

export const TopAdvisorsLeaderboard = ({ advisors }: TopAdvisorsLeaderboardProps) => {
  if (advisors.length === 0) {
    return (
      <ChartContainer title={TITLE} subtitle={SUBTITLE}>
        <EmptyState message="No advisor activity for the selected filters." />
      </ChartContainer>
    );
  }

  return (
    <ChartContainer title={TITLE} subtitle={SUBTITLE}>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-200 text-xs font-medium uppercase tracking-wider text-gray-500">
              <th className="py-2 px-3 text-left">#</th>
              <th className="py-2 px-3 text-left">Advisor</th>
              <th className="py-2 px-3 text-left">Firm</th>
              <th className="py-2 px-3 text-right">Actions</th>
              <th className="py-2 px-3 text-right">Referrals</th>
              <th className="py-2 px-3 text-right">Clients</th>
            </tr>
          </thead>
          <tbody>
            {advisors.map((a, i) => (
              <tr key={`${a.advisorName}-${i}`} className="border-b border-gray-100 hover:bg-gray-50">
                <td className="py-2 px-3 text-gray-400">{i + 1}</td>
                <td className="py-2 px-3 font-medium text-gray-900">{a.advisorName}</td>
                <td className="py-2 px-3 text-gray-600">{a.firmName ?? '—'}</td>
                <td className="py-2 px-3 text-right text-gray-900">
                  {a.totalActions.toLocaleString('en-US')}
                </td>
                <td className="py-2 px-3 text-right text-gray-600">
                  {a.referrals.toLocaleString('en-US')}
                </td>
                <td className="py-2 px-3 text-right text-gray-600">
                  {a.clientsEngaged.toLocaleString('en-US')}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </ChartContainer>
  );
};
